import React, {useState, useEffect} from 'react'
import './EditCensorModal.css'
import apiClient from '../api/apiClient'

export default function CreateTestGroupModal({schoolID, onCreate, onClose}){
    const [terminer, setTerminer] = useState([])
    const [formData, setFormData] =useState({
        navn: '', 
        sprogcenter_id: schoolID,
        termin_id: 0, 
        studie: 'PD1' 
    })


    async function fetchTermin(){
        try{
            const result = await apiClient.get('/api/testgroup/fetchterminer')
            setTerminer(result.data)
        }catch(e){
            console.log("fejl ved fetch termin")
            console.log(e)
        }
    }

    function handleSubmit(e){
        e.preventDefault()
        onCreate(formData)
    }

    useEffect(()=>{
        fetchTermin()
    }, [])

    return(
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2 className="modal-title">Opret prøvegruppe</h2>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <form onSubmit={(e)=>handleSubmit(e)}>
                    <div className="modal-form-grid">
                        <div className="form-group">
                            <label>Prøvegruppenavn:</label>
                            <input type="text" value={formData.navn}
                                onChange={(e)=>setFormData({...formData, navn: e.target.value})}/>
                        </div>
                        <div className="form-group">
                            <label>Termin:</label>
                            <select value={formData.termin_id} onChange={(e)=>setFormData({...formData, termin_id: parseInt(e.target.value)})}>
                                <option value="0" disabled>Vælg termin</option>
                                {terminer.map((termin) => (
                                    <option key={termin.id} value={termin.id}>{termin.navn}</option>
                                ))}
                            </select>                                
                        </div>
                        <div className ="form-group">
                            <label>Prøvetype:</label>
                            <select value={formData.studie} onChange={(e)=> setFormData({...formData, studie: e.target.value})}>
                                <option key="PD1" value="PD1">PD1</option>
                                <option key="PD2" value="PD2">PD2</option>
                                <option key="PD3" value="PD3">PD3</option>
                            </select>
                        </div>
                        <div className="modal-actions" style={{marginTop: '20px'}}>
                            <button type="button" className="btn-cancel" onClick={onClose}>Annuller</button>
                            <button type="submit" className="btn-save">Opret prøvegruppe</button> 
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}